import React from 'react';

/**
 * Avatar component that displays either a profile photo or a gradient initial
 * @param {string} name - User's name (for initial and gradient generation)
 * @param {string} email - User's email (for gradient generation)
 * @param {string} profilePhotoUrl - URL to user's profile photo (optional)
 * @param {string} size - Size class (e.g., 'w-10 h-10', 'w-12 h-12')
 * @param {string} textSize - Text size class for initial (e.g., 'text-lg', 'text-xl')
 */
function Avatar({ name, email, seed, profilePhotoUrl, size = 'w-10 h-10', textSize = 'text-base' }) {
  const [imageError, setImageError] = React.useState(false);

  React.useEffect(() => {
    setImageError(false);
  }, [profilePhotoUrl]);

  // Generate gradient style for fallback
  const getAvatarStyle = email => {
    if (!email)
      return {
        background: 'linear-gradient(to bottom right, #9ca3af, #4b5563)',
      };

    let hash = 0;
    for (let i = 0; i < email.length; i++) {
      hash = email.charCodeAt(i) + ((hash << 5) - hash);
    }

    const hue1 = Math.abs(hash) % 360;
    const hue2 = (hue1 + 60) % 360;

    const color1 = `hsl(${hue1}, 70%, 60%)`;
    const color2 = `hsl(${hue2}, 70%, 55%)`;

    return {
      background: `linear-gradient(to bottom right, ${color1}, ${color2})`,
    };
  };

  // Show image if URL exists and hasn't errored
  if (profilePhotoUrl && !imageError) {
    return (
      <img
        src={profilePhotoUrl}
        alt={name}
        className={`${size} rounded-full object-cover flex-shrink-0`}
        onError={() => setImageError(true)}
      />
    );
  }

  // Fallback to gradient avatar
  return (
    <div
      className={`${size} rounded-full flex items-center justify-center text-white font-bold flex-shrink-0 ${textSize}`}
      style={getAvatarStyle(email || seed)}
    >
      {name?.charAt(0).toUpperCase() ?? '?'}
    </div>
  );
}

export default Avatar;
